import { Divider, makeStyles, Paper, Table, TableBody } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import ActionsContextV2 from '../ActionsContextV2';
import ActionsFormApprovedGroupHeaderV2 from './ActionsFormApprovedGroupHeaderV2';
import ActionsFormApprovedGroupItemV2 from './ActionsFormApprovedGroupItemV2';
import ActionsPendingFormItemV2 from './ActionsPendingFormItemV2';
import ActionsStepperV2 from './ActionsStepperV2';
import ActionFormLoadingEmptyState from './ActionFormLoadingEmptyState';
import ActionFormNoActionsEmptyState from './ActionFormNoActionsEmptyState';
import ActionFormNoPendingEmptyState from './ActionFormNoPendingEmptyState';
import ActionsFormPendingGroupHeaderV2 from './ActionsFormPendingGroupHeaderV2';
import ActionsFormEmptyStateV2 from './ActionsFormEmptyStateV2';
import CenteredLoadingIndicator from '../../common/CenteredLoadingIndicator';

import _ from 'lodash';

const PaperContainer = styled.div`
    padding: 10px;
    width:100%;
`;

const Toolbar = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding-right:20px;
    width:100%;
`
const TitleContainer = styled.div`
    display:flex;
    align-items:left;
    flex-direction:column;

`;



const ActionStepperContainer = styled.div`
    
`
const ProcedureManualCheckedButton = styled.img`
height:50px;
width:47px;
`;

const useStyles = makeStyles({
    root: {
        width: '100%',
        position: 'sticky',
    },
    container: {
        maxHeight: 100,
    },
    table: {
        position: 'sticky',
    },
});

const TableContainer = styled.div`
    width:100%;
    overflow-y:auto;
    height: calc(100vh - 500px) !important 
`;


const ActionsFormGroupV2 = ({ formProps, groupIndex, readOnly, setAllToComplyAsIsFlag = false, setSetAllToComplyAsIsFlag = () => { }, setIsEnableSetAllToYesMenu = () => { } }) => {

    const context = useContext(ActionsContextV2);
    const [isShowLoader, setIsShowLoader] = useState(false)

    const columnTitleValues = [
        { title: 'Reasoning', value: 'Reasoning' },
        { title: 'Applicability', value: 'Applicability' },
        { title: 'Procedure SDN', value: 'Procedure SDN' },
        { title: 'Procedure Name', value: 'Procedure Name' },
        { title: 'Rev', value: 'Rev' },
        { title: 'Effective Date', value: 'Effective Date' },
        { title: 'Status', value: 'Status' },
        { title: 'Comment', value: 'Comment' }
    ];

    const classes = useStyles();
    const { submittingPendingActions, pendingSortProperty, pendingSortReverse, approvedSortProperty, approvedSortReverse } = context.actionsRedux;

    const { masterWorkflowSteps, pendingActions, approvedActions, currentStepIndex = 0 } = context.actionsRedux.selectedProjectFunctionDetails;

    const masterWorkflowStep = masterWorkflowSteps[currentStepIndex];
    let actionsToDisplay = pendingActions.filter(action => action.currentStepIndex === currentStepIndex);
    actionsToDisplay = _.orderBy(actionsToDisplay, action => (typeof action[pendingSortProperty] === 'string') ? action[pendingSortProperty].toUpperCase() : action[pendingSortProperty]);
    actionsToDisplay = pendingSortReverse ? actionsToDisplay : _.reverse(actionsToDisplay);

    actionsToDisplay = !context.searchText ? actionsToDisplay : actionsToDisplay.filter(action => {
        const sdnToUse = action.alternateSdn ? action.alternateSdn : action.procedureSdn;
        return `${sdnToUse} ${action.procedureName}`.toUpperCase().includes(context.searchText.toUpperCase());
    });

    // apply category filter
    actionsToDisplay = !context.categoryFilterText || context.categoryFilterText === 'All' ? actionsToDisplay : actionsToDisplay.filter(action => {
        const categoryName = action.categoryName;
        return `${categoryName}`.toUpperCase().includes(context.categoryFilterText.toUpperCase());
    });

    // apply Compliance filter
    if (context.complianceFilterText === 'None') {
        actionsToDisplay = actionsToDisplay.filter(action => {
            return action.applicability === null;
        });
    } else {
        actionsToDisplay = !context.complianceFilterText || context.complianceFilterText === 'All' ? actionsToDisplay : actionsToDisplay.filter(action => {
            const applicability = action.applicability;
            return `${applicability}`.toUpperCase().includes(context.complianceFilterText.toUpperCase());
        });
    }


    let approvedActionsToDisplay = _.orderBy(approvedActions, action => (typeof action[approvedSortProperty] === 'string') ? action[approvedSortProperty].toUpperCase() : action[approvedSortProperty]);
    approvedActionsToDisplay = approvedSortReverse ? approvedActionsToDisplay : _.reverse(approvedActionsToDisplay);

    approvedActionsToDisplay = !context.searchText ? approvedActionsToDisplay : approvedActionsToDisplay.filter(action => {
        const sdnToUse = action.alternateSdn ? action.alternateSdn : action.procedureSdn;
        return `${sdnToUse} ${action.procedureName}`.toUpperCase().includes(context.searchText.toUpperCase());
    });

    // apply category filter
    approvedActionsToDisplay = !context.categoryFilterText || context.categoryFilterText === 'All' ? approvedActionsToDisplay : approvedActionsToDisplay.filter(action => {
        const categoryName = action.categoryName;
        return `${categoryName}`.toUpperCase().includes(context.categoryFilterText.toUpperCase());
    });

    // apply Compliance filter
    if (context.complianceFilterText === 'None') {
        approvedActionsToDisplay = approvedActionsToDisplay.filter(action => {
            return action.applicability === null;
        });
    } else {
        approvedActionsToDisplay = !context.complianceFilterText || context.complianceFilterText === 'All' ? approvedActionsToDisplay : approvedActionsToDisplay.filter(action => {
            const applicability = action.applicability;
            return `${applicability}`.toUpperCase().includes(context.complianceFilterText.toUpperCase());
        });
    }

    let isProjectFunctionSetUp = true;
    if (masterWorkflowSteps.length === 0 && pendingActions.length === 0
        && approvedActions.length === 0 && actionsToDisplay.length === 0) {
        isProjectFunctionSetUp = false;
    }

    const pendingCounts = pendingActions.map((key) => {
        return key.masterWorkflowStepIndex
    });
    const pendingActionsCounts = pendingCounts.reduce((prev, curr) => {
        return (prev[curr] = ++prev[curr] || 1, prev)
    }, {})


    useEffect(() => {
        const temActions = [];
        const value = 'YES';
        const currentStepIndex = context.actionsRedux.selectedProjectFunctionDetails.currentStepIndex;

        const masterWorkflowStep = context.actionsRedux.selectedProjectFunctionDetails.masterWorkflowSteps[currentStepIndex];
        let isEditable = masterWorkflowStep && (masterWorkflowStep.isCurrentUser || masterWorkflowStep.isProxy);
        const applicabilityOption = context.actionsRedux.applicabilityOptionsObject[value];

        actionsToDisplay.map((action, index) => {
            if (action.applicabilityId != 'YES') {
                if (applicabilityOption && applicabilityOption.requiresDeviationReasoning === true) {
                    context.displayDeviationReasoning({ action: { ...action, applicabilityId: value }, deviationReasoningClearApplicabilityOnCancel: true, isEditable });
                } else {
                    // we need to make following fields empty on selecting Yes. comply as-is
                    let tempAction = { ...action }
                    if (value == 'YES') {
                        tempAction = {
                            ...action,
                            deviationType: 0,
                            isDeviating: false,
                            modifiedProcedureEffectiveDate: '',
                            modifiedProcedureRev: '',
                            modifiedProcedureSdn: '',
                            modifiedProcedureTitle: '',
                            modifiedProcedureUrl: '',
                            deviationReasoning: '',
                            deviationComments: '',
                            applicabilityId: value
                        }
                    }

                    // context.updateAction(tempAction, { applicabilityId: value });
                    temActions.push(tempAction);
                }

                // context.updateScrollTop(context.scrollRef.current.scrollTop);
            }
        })

        setIsEnableSetAllToYesMenu(temActions.length)


    }, [])

    useEffect(() => {
        if (setAllToComplyAsIsFlag != false) {
            const temActions = [];
            const value = 'YES';
            const currentStepIndex = context.actionsRedux.selectedProjectFunctionDetails.currentStepIndex;

            const masterWorkflowStep = context.actionsRedux.selectedProjectFunctionDetails.masterWorkflowSteps[currentStepIndex];
            let isEditable = masterWorkflowStep && (masterWorkflowStep.isCurrentUser || masterWorkflowStep.isProxy);
            const applicabilityOption = context.actionsRedux.applicabilityOptionsObject[value];

            actionsToDisplay.map((action, index) => {
                if (action.applicabilityId != 'YES') {
                    if (applicabilityOption && applicabilityOption.requiresDeviationReasoning === true) {
                        context.displayDeviationReasoning({ action: { ...action, applicabilityId: value }, deviationReasoningClearApplicabilityOnCancel: true, isEditable });
                    } else {
                        // we need to make following fields empty on selecting Yes. comply as-is
                        let tempAction = { ...action }
                        if (value == 'YES') {
                            tempAction = {
                                ...action,
                                deviationType: 0,
                                isDeviating: false,
                                modifiedProcedureEffectiveDate: '',
                                modifiedProcedureRev: '',
                                modifiedProcedureSdn: '',
                                modifiedProcedureTitle: '',
                                modifiedProcedureUrl: '',
                                deviationReasoning: '',
                                deviationComments: '',
                                applicabilityId: value
                            }
                        }

                        // context.updateAction(tempAction, { applicabilityId: value });
                        temActions.push(tempAction);
                    }

                    // context.updateScrollTop(context.scrollRef.current.scrollTop);
                }
            })

            if (temActions.length) {
                setIsShowLoader(true);
                setIsEnableSetAllToYesMenu(0);
                context.updateAllAction(temActions)
                    .then((res) => {
                        setIsShowLoader(false);
                        context.updateScrollTop(context.scrollRef.current.scrollTop);
                    })
                    .catch((error) => {
                        setIsShowLoader(false);
                        console.error('Error updating actions:', error);
                    });

            } else {
                alert('Already All are set to Comply as is');
            }
        }

    }, [setAllToComplyAsIsFlag])


    useEffect(()=>{
        
        // const notYesItems = actionsToDisplay.filter((item)=>{
        //     console.log('-----', item.applicabilityId)
        //     return item.applicabilityId != 'YES' || item.applicabilityId == null
        // })

        const noAndNAItems = actionsToDisplay.filter((item)=>{
            console.log('-----', item.applicabilityId)
            return item.applicabilityId == 'NA' || item.applicabilityId == 'NO'
        })

        setIsEnableSetAllToYesMenu(noAndNAItems.length > 0 ? false : true)
    }, [actionsToDisplay])

    return (
        <>
            {isShowLoader && <CenteredLoadingIndicator />}
            {!isShowLoader && <PaperContainer>
                <Paper>
                    {context.pendingCompletedTab === 0 &&
                        <>
                            {isProjectFunctionSetUp && <ActionStepperContainer>
                                <ActionsStepperV2
                                    onStepIndexChanged={stepIndex => context.setPendingStepIndex(stepIndex)}
                                    contentWidth={context.contentWidth}
                                    activeStep={currentStepIndex}
                                    //  workflows={context.hoverAction ?  context.hoverAction.workflowSteps : masterWorkflowSteps  }  
                                    workflows={masterWorkflowSteps}
                                    fieldName={`actionGroups.${groupIndex}.currentUserStepIndex`}
                                    actionWorkflows={context.hoverAction ? context.hoverAction.workflowSteps : null}
                                    pendingActionsCounts={pendingActionsCounts}
                                />
                            </ActionStepperContainer>}
                            {isProjectFunctionSetUp && <Divider />}

                            {(!submittingPendingActions && actionsToDisplay.length > 0) &&
                                <>
                                    <TableContainer>
                                        <Table className={`${classes.table} ${classes.container} ${classes.root}`} >

                                            <ActionsFormPendingGroupHeaderV2 readOnly={readOnly} currentStepIndex={currentStepIndex} />

                                            <TableBody>
                                                {actionsToDisplay.map((action, index) => <ActionsPendingFormItemV2 key={index} readOnly={readOnly} formProps={formProps} action={action} setSetAllToComplyAsIsFlag={setSetAllToComplyAsIsFlag} />)}
                                            </TableBody>

                                        </Table>
                                    </TableContainer>

                                </>
                            }

                            {(!isProjectFunctionSetUp) &&
                                <ActionsFormEmptyStateV2 title="No procedures to show." subtitle="The project hasn't set up this function yet." showSVG="true" />
                            }

                            {(!submittingPendingActions && isProjectFunctionSetUp && pendingActions.length > 0 && actionsToDisplay.length === 0
                                && (context.complianceFilterText !== '' || context.categoryFilterText !== '') && !context.searchText) &&
                                <ActionsFormEmptyStateV2 subtitle="No procedures match the selected filter criteria" />
                            }

                            {submittingPendingActions && <ActionFormLoadingEmptyState />}
                            {(!submittingPendingActions && isProjectFunctionSetUp && pendingActions.length === 0 && context.complianceFilterText === '' && context.categoryFilterText === '')
                                && <ActionFormNoPendingEmptyState readOnly={readOnly} />}
                            {(!submittingPendingActions && pendingActions.length > 0 && actionsToDisplay.length === 0 && !context.searchText
                                && context.complianceFilterText === '' && context.categoryFilterText === '') &&
                                <ActionFormNoActionsEmptyState
                                    masterWorkflowStep={masterWorkflowStep}
                                />
                            }

                        </>
                    }
                    {context.pendingCompletedTab === 1 &&
                        <>
                            <Divider />
                            {!submittingPendingActions && approvedActionsToDisplay.length > 0 &&
                                <Table className={classes.table} >


                                    <ActionsFormApprovedGroupHeaderV2 readOnly={readOnly} />
                                    <TableBody>
                                        {approvedActionsToDisplay.map((action, index) => <ActionsFormApprovedGroupItemV2 key={index} readOnly={readOnly} formProps={formProps} action={action} />)}
                                    </TableBody>

                                </Table>
                            }

                            {!submittingPendingActions && approvedActionsToDisplay.length === 0 && (context.complianceFilterText !== '' || context.categoryFilterText !== '') &&
                                <ActionsFormEmptyStateV2 subtitle="No procedures match the selected filter criteria" />
                            }

                            {!submittingPendingActions && approvedActionsToDisplay.length === 0 && context.complianceFilterText === '' && context.categoryFilterText === '' &&
                                <ActionsFormEmptyStateV2 subtitle="No procedures have been completed yet" />
                            }
                            {isProjectFunctionSetUp && submittingPendingActions && context.complianceFilterText === '' && context.categoryFilterText === '' &&
                                <ActionFormLoadingEmptyState />
                            }
                        </>
                    }
                </Paper>
            </PaperContainer>}
        </>
    );


}

export default ActionsFormGroupV2;